<template>
    <v-form v-model="form" ref="form">
        <v-layout row wrap>
            <v-flex xs12 sm4 md2 px-2>
                <v-select
                    v-model="select"
                    item-text="description"
                    item-value="id"
                    :items="imageTypes"
                    label="Image Type"
                    :disabled="disabled">
                </v-select>
            </v-flex>
            <v-flex xs3 sm2 md1 px-2 v-if="select === 1">
                <v-select
                    v-model="licenseState"
                    :items="states"
                    item-value="id"
                    item-text="description"
                    label="State"
                    :disabled="disabled">
                </v-select>
            </v-flex>
            <v-flex xs9 sm6 md2 px-2 v-if="select === 1">
                <v-text-field
                    label="License Number"
                    v-mask="getStateLicenseMask(licenseState)"
                    :placeholder="getStateLicenseMask(licenseState)"
                    :rules="validateLicense(licenseState, licenseNumber)"
                    required
                    v-model="licenseNumber"
                    :disabled="disabled"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm8 md5 px-2>
                <v-file-input
                    small-chips counter show-size
                    accept="image/*" v-model="image"
                    label="All Image Types are Acceptable"
                    :disabled="disabled"
                ></v-file-input>
            </v-flex>
            <v-flex xs12 sm4 md2 px-2>
                <v-btn :disabled="disabled" @click="btnClick()">Upload Image</v-btn>
            </v-flex>
            <v-flex xs12>
                <v-data-table
                    :items="mediaList"
                    :headers="mediaListHeaders"
                    no-data-text="No files available"
                >
                    <template v-slot:item.view="{item}"> <!--this error is a lie-->
                        <td><v-btn :icon="true" @click="download(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template v-slot:item.base64Image="{item}"> <!--this error is a lie-->
                        <td><img :src="'data:image/;base64,' + item.base64Image" width="80" height="80"/></td>
                    </template>
                    <template v-slot:item.delete="{item}"> <!--this error is a lie-->
                        <td><v-btn :disabled="disabled" :icon="true" @click="deleteMedia(item)"><v-icon dark>mdi-trash-can-outline</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import certService from '@/services/certificateService'
import mediaService from '@/services/mediaService'
import lookupService from '@/services/lookupService'
import driversLicenseService from '@/services/util/driversLicenseService'
import { mask } from 'vue-the-mask'

export default {
    directives: {
        mask
    },
    props: {
        disabled: null
    },
    mounted () {
        lookupService.GetCertificateImageTypes(this.$http).then(response => {
            this.imageTypes = response.data
        })
        lookupService.GetStateAbbrs(this.$http).then(response => {
            this.states = response.data
        })
        this.driversLicenseStates = driversLicenseService.states
    },
    data: function () {
        return {
            mediaList: [],
            image: null,
            select: -1,
            licenseNumber: null,
            licenseState: null,
            mediaListHeaders:
            [
                { text: 'View', value: 'view' },
                { text: 'Image', value: 'base64Image' },
                { text: 'File Name', value: 'fileName' },
                { text: 'Create Date', value: 'createDate' },
                { text: 'Delete', value: 'delete' }
            ],
            imageTypes: [],
            states: [],
            driversLicenseStates: [],
            form: false
        }
    },
    methods: {
        btnClick () {
            if (this.$refs.form.validate() || this.select !== 1) {
                this.$emit('send-message')
            }
        },
        setCertId (certId) {
            this.certificateId = certId
        },
        loadImages (modType, certId) {
            certService.getImagesByCertificate(this.$http, modType, certId).then(resp => {
                this.mediaList = resp.data
            })
        },
        deleteMedia (item) {
            if (confirm('Are you sure you want to remove this file/document?')) {
                certService.deleteImage(this.$http, item.portalCertificateOrderImageId)
                this.mediaList = this.mediaList.filter(m => m.portalCertificateOrderImageId !== item.portalCertificateOrderImageId)
            }
        },
        download (item) {
            certService.getImage(this.$http, item.portalCertificateOrderImageId).then(response => {
                mediaService.fileToDownload(response, item.fileName)
            })
        },
        uploadImage (certId, modType) {
            if (this.image) {
                var formData = new FormData()
                formData.append('certificateId', certId)
                formData.append('moduleType', modType)
                formData.append('imageType', this.select)
                if (this.select === 1) {
                    formData.append('extraInformation', this.licenseNumber)
                    formData.append('licenseStateId', this.licenseState)
                }
                formData.append(this.image.name, this.image)
                certService.saveFiles(this.$http, formData).then(response => {
                    this.loadImages(modType, certId)
                    this.image = null
                    this.select = -1
                    this.licenseNumber = null
                })
            }
        },
        getStateLicenseMask (state) {
            var obj = this.driversLicenseStates.find(x => x.Id === state)
            return obj ? obj.Mask : 'XXXXXXXXXXXXXXXX' // If state validation not set 15 chars of Any symbol (New Jersey can be 15)
        },
        validateLicense (state, license) {
            return [driversLicenseService.validateLicense(state, license) || 'Incorrect license format']
        }
    }
}
</script>
